// DevGitConfirmModal.js — HITL commit / restore / push

import React from 'react';
import { AlertTriangle, GitCommit, RotateCcw, Upload } from 'lucide-react';
import './devCockpit.css';

const ICONS = {
    commit: GitCommit,
    restore: RotateCcw,
    push: Upload,
};

export default function DevGitConfirmModal({
    type = 'commit',
    title,
    description,
    detail,
    confirmLabel,
    onConfirm,
    onCancel,
    loading,
    danger,
}) {
    const Icon = ICONS[type] || AlertTriangle;

    return (
        <div className="dev-modal-overlay">
            <div className={`dev-modal${danger ? ' dev-modal--danger' : ''}`}>
                <div style={{ display: 'flex', gap: 10, marginBottom: 14 }}>
                    <Icon size={20} color={danger ? '#f87171' : '#fbbf24'} />
                    <h3>{title}</h3>
                </div>
                <p>{description}</p>
                {detail && <code className="dev-modal__path">{detail}</code>}
                <div className="dev-modal__actions">
                    <button type="button" onClick={onCancel} disabled={loading} className="dev-btn">
                        Annuler
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={loading}
                        className={`dev-btn${danger ? '' : ' dev-btn--primary'}`}
                        style={danger ? { borderColor: '#f87171', color: '#f87171' } : undefined}
                    >
                        {loading ? 'En cours…' : confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}
